import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumDashboardComponent implements BaseEnumType {
  private static allValues: EnumDashboardComponent[] = []; // make sure this is top-most
  
  public static none = new EnumDashboardComponent(0, "None", "enum_dashboard_component_none");
  public static openOrders = new EnumDashboardComponent(1, "OpenOrders", "enum_dashboard_component_open_orders");
  public static ordersCreated = new EnumDashboardComponent(2, "OrdersCreated", "enum_dashboard_component_orders_created");
  public static inProgressAssemblies = new EnumDashboardComponent(3, "InProgressAssemblies", "enum_dashboard_component_in_progress_assemblies");
  public static activeLeads = new EnumDashboardComponent(4, "ActiveLeads", "enum_dashboard_component_active_leads");
  public static creditNotesCreated = new EnumDashboardComponent(5, "CreditNotesCreated", "enum_dashboard_component_credit_notes_created");
  public static openCreditNotes = new EnumDashboardComponent(6, "OpenCreditNotes", "enum_dashboard_component_open_credit_notes");
  public static totalAgeingCasks = new EnumDashboardComponent(7, "TotalAgeingCasks", "enum_dashboard_component_total_ageing_casks");
  public static vesselsInUse = new EnumDashboardComponent(8, "VesselsInUse", "enum_dashboard_component_vessels_in_use");
  public static totalLitreage = new EnumDashboardComponent(9, "TotalLitreage", "enum_dashboard_component_total_litreage");
  public static calendar = new EnumDashboardComponent(10, "Calendar", "enum_dashboard_component_calendar");
  public static overdueTasks = new EnumDashboardComponent(11, "OverdueTasks", "enum_dashboard_component_overdue_tasks");
  public static dueTasks = new EnumDashboardComponent(12, "DueTasks", "enum_dashboard_component_due_tasks");
  public static ordersOverdueForDispatch = new EnumDashboardComponent(13, "OrdersOverdueForDispatch", "enum_dashboard_component_orders_overdue_for_dispatch");
  public static ordersDueForDispatchToday = new EnumDashboardComponent(14, "OrdersDueForDispatchToday", "enum_dashboard_component_orders_due_for_dispatch_today");
  public static assembliesDueToStart = new EnumDashboardComponent(15, "AssembliesDueToStart", "enum_dashboard_component_assemblies_due_to_start");
  public static assembliesDueToEnd = new EnumDashboardComponent(16, "AssembliesDueToEnd", "enum_dashboard_component_assemblies_due_to_end");
  public static distributionPlanningMismatch = new EnumDashboardComponent(17, "DistributionPlanningMismatch", "enum_dashboard_component_distribution_planning_mismatch");
  public static distributionPlanningHasNotes = new EnumDashboardComponent(18, "DistributionPlanningHasNotes", "enum_dashboard_component_distribution_planning_has_notes");
  public static todaysPlannedJourneys = new EnumDashboardComponent(19, "TodaysPlannedJourneys", "enum_dashboard_component_todays_planned_journeys");
  public static courierPickups = new EnumDashboardComponent(20, "CourierPickups", "enum_dashboard_component_courier_pickups");
  public static collections = new EnumDashboardComponent(21, "Collections", "enum_dashboard_component_collections");
  public static stockReplenishment = new EnumDashboardComponent(22, "StockReplenishment", "enum_dashboard_component_stock_replenishment");
  public static stockAdjustment = new EnumDashboardComponent(23, "StockAdjustment", "enum_dashboard_component_stock_adjustment");
  public static stockTransfer = new EnumDashboardComponent(24, "StockTransfer", "enum_dashboard_component_stock_transfer");
  public static posDueForDelivery = new EnumDashboardComponent(25, "PosDueForDelivery", "enum_dashboard_component_pos_due_for_delivery");
  public static changelog = new EnumDashboardComponent(26, "Changelog", "enum_dashboard_component_changelog");
  public static christmas2024 = new EnumDashboardComponent(27, "Christmas2024", "enum_dashboard_component_christmas2024");
  public static christmasCountdown2024 = new EnumDashboardComponent(28, "ChristmasCountdown2024", "enum_dashboard_component_christmas_countdown2024");
  public static postingErrors = new EnumDashboardComponent(29, "PostingErrors", "enum_dashboard_component_posting_errors");
  public static openUllages = new EnumDashboardComponent(30, "OpenUllages", "enum_dashboard_component_open_ullages");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumDashboardComponent.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumDashboardComponent.none; }
  public isOpenOrders() { return this === EnumDashboardComponent.openOrders; }
  public isOrdersCreated() { return this === EnumDashboardComponent.ordersCreated; }
  public isInProgressAssemblies() { return this === EnumDashboardComponent.inProgressAssemblies; }
  public isActiveLeads() { return this === EnumDashboardComponent.activeLeads; }
  public isCreditNotesCreated() { return this === EnumDashboardComponent.creditNotesCreated; }
  public isOpenCreditNotes() { return this === EnumDashboardComponent.openCreditNotes; }
  public isTotalAgeingCasks() { return this === EnumDashboardComponent.totalAgeingCasks; }
  public isVesselsInUse() { return this === EnumDashboardComponent.vesselsInUse; }
  public isTotalLitreage() { return this === EnumDashboardComponent.totalLitreage; }
  public isCalendar() { return this === EnumDashboardComponent.calendar; }
  public isOverdueTasks() { return this === EnumDashboardComponent.overdueTasks; }
  public isDueTasks() { return this === EnumDashboardComponent.dueTasks; }
  public isOrdersOverdueForDispatch() { return this === EnumDashboardComponent.ordersOverdueForDispatch; }
  public isOrdersDueForDispatchToday() { return this === EnumDashboardComponent.ordersDueForDispatchToday; }
  public isAssembliesDueToStart() { return this === EnumDashboardComponent.assembliesDueToStart; }
  public isAssembliesDueToEnd() { return this === EnumDashboardComponent.assembliesDueToEnd; }
  public isDistributionPlanningMismatch() { return this === EnumDashboardComponent.distributionPlanningMismatch; }
  public isDistributionPlanningHasNotes() { return this === EnumDashboardComponent.distributionPlanningHasNotes; }
  public isTodaysPlannedJourneys() { return this === EnumDashboardComponent.todaysPlannedJourneys; }
  public isCourierPickups() { return this === EnumDashboardComponent.courierPickups; }
  public isCollections() { return this === EnumDashboardComponent.collections; }
  public isStockReplenishment() { return this === EnumDashboardComponent.stockReplenishment; }
  public isStockAdjustment() { return this === EnumDashboardComponent.stockAdjustment; }
  public isStockTransfer() { return this === EnumDashboardComponent.stockTransfer; }
  public isPosDueForDelivery() { return this === EnumDashboardComponent.posDueForDelivery; }
  public isChangelog() { return this === EnumDashboardComponent.changelog; }
  public isChristmas2024() { return this === EnumDashboardComponent.christmas2024; }
  public isChristmasCountdown2024() { return this === EnumDashboardComponent.christmasCountdown2024; }
  public isPostingErrors() { return this === EnumDashboardComponent.postingErrors; }
  public isOpenUllages() { return this === EnumDashboardComponent.openUllages; }

  public static getValues(): readonly EnumDashboardComponent[] {
    return EnumDashboardComponent.allValues;
  }

  public static getValuesExcept0(): readonly EnumDashboardComponent[] {
    return EnumDashboardComponent.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumDashboardComponent {
    const found = EnumDashboardComponent.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDashboardComponent - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumDashboardComponent): EnumDashboardComponent {
    const found = name ? EnumDashboardComponent.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumDashboardComponent - Value not found: ${ name }`);
    }

    return found;
  }
}